export default __webpack_public_path__ + "static/banner-mobile-02dbb4591a94160f3dc0ea3930a24c40.svg";